import Stack from '@mui/joy/Stack';

import CircularProgress from '@mui/joy/CircularProgress';
import Typography from '@mui/joy/Typography';

export default function LoadingScreenBig({title="Hi!", message="Nice to see you"}: {title?: string, message?: string}) {

    return (
        <Stack

            width={"100vw"}
            height={"100vh"}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
        >
            <CircularProgress />
            <Typography level="title-lg">{title}</Typography>
            <Typography level="body-sm">{message}</Typography>
        </Stack>
    );
}
